module.exports = __webpack_public_path__ + "img/iconmonstr-twitter-1.631cd566.svg";